export default "__VITE_ASSET__CQAFx1____"